import { POST_API_PATH, GET_API_PATH } from "../../../constants"
import apiSetting from "../apiSetting"

const getDeliverOrders = async (data) => {
    try {
        const queryParams = new URLSearchParams(data).toString();
        const response = await apiSetting({ method: 'GET', url: `${GET_API_PATH.GET_URL_DELIVER_ORDERS}?${queryParams}`, data: null })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const createDeliverOrder = async (data) => {
    try {
        const response = await apiSetting({ method: 'POST', url: POST_API_PATH.POST_URL_CREATE_DELIVER_ORDER, data: data })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const updateDeliverOrder = async (data) => {
    try {
        const response = await apiSetting({ method: 'POST', url: POST_API_PATH.POST_URL_UPDATE_DELIVER_ORDER, data: data })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const returnDeliverOrder = async (deliverOrderId) => {
    try {
        const response = await apiSetting({ method: 'POST', url: `${POST_API_PATH.POST_URL_RETURN_DELIVER_ORDER}`, data: { id: deliverOrderId } })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const completeDelivery = async (deliverOrderId) => {
    try {
        const response = await apiSetting({ method: 'POST', url: `${POST_API_PATH.POST_URL_COMPLETE_DELIVERY}`, data: { id: deliverOrderId } })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

export { getDeliverOrders, createDeliverOrder, updateDeliverOrder, returnDeliverOrder, completeDelivery } 